import { AdminRouteName } from '../../../CONSTANTS';
import RentCollectionTableRecords from '../RentCollectionTableRecords';

const optionalColumn = [
  'dateActioned',
];

const optionalColumnLabelFormat = {
  dateActioned: 'Date Actioned',
};

const SettledRentCollection = () => (
  <RentCollectionTableRecords
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    tabStatus="SETTLED"
    defaultUrl={AdminRouteName.rentCollectionSettledRoute}
    toggleStorageId="settled_rent-collection-table-col"
    hasNameAndImage
    permissionName="can-view-rent-payment"
  />
);
export default SettledRentCollection;
